import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { Message, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../../ButtonPanel'
import ViewFormWidget from '../dynamicForm/ViewFormWidget'
import EditFormWidget from '../dynamicForm/EditFormWidget'
import HTMLWidget from '../../HTMLWidget'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import { saveFormOperationArea } from '../../../redux/actions/subProjectProposal'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { setAlertMessage } from '../../../utils/messageUtil'
import { doneLoading, startLoading } from '../../../utils/loading'

export default function OperationAreaWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormOperationArea(subProjectId, request)
      if (response) {
        setFormSchema(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = []
    let subForm = []

    formSchema.objects?.forEach((e) => {
      if (e.type == 'HEADER_LABEL' || e.type == 'LABEL') {
        //ไม่ทำอะไร
      } else if (e.type == 'ADDRESS') {
        e.subSchemas?.forEach((se) => {
          let subValues = []

          se.objects?.forEach((seo) => {
            subValues.push({
              key: se.typeId,
              name: seo.name,
              value: data[seo.name] || null,
              type: seo.type,
            })
          })

          subForm.push({
            id: se.id,
            typeId: e.id,
            values: subValues,
          })
        })
      } else {
        values.push({
          key: e.id,
          name: e.name,
          value: data[e.name] || null,
          type: e.type,
        })
      }
    })

    let request = {
      id: formSchema.id,
      values: values,
      subForm: subForm,
    }

    console.log('request : ', JSON.stringify(request))

    handleSave(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}

      {formSchema.notSpatialMsg && (
        <span style={{ marginLeft: 20 }}>
          <strong>{formSchema.notSpatialMsg}</strong>
        </span>
      )}

      {isEdit && showCommandButton ? (
        <>
          <EditFormWidget
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </>
      ) : (
        <>
          <ViewFormWidget schema={formSchema} />
        </>
      )}

      {formSchema.note && (
        <Message
          showIcon
          type="info"
          style={{ marginTop: 20 }}
          description={<HTMLWidget data={formSchema.note} />}
        />
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )}

          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </div>
      )}
    </Panel>
  )
}
